'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { MainLocale } from '../../../../../i18n/constants';
import { useProgressValidator } from '../hooks/useProgressValidator';
import { useLicenseStore } from '../licenseStore';
import type { SanityLicense } from '../types/licenses';

export const ProgressValidator = ({ license, locale }: { license: SanityLicense; locale: MainLocale }) => {
  const router = useRouter();
  const isHydrated = useLicenseStore(s => s.isHydrated);
  const { canAccessCurrent, flow, steps } = useProgressValidator(license);

  useEffect(() => {
    if (!isHydrated) return;
    if (flow && !canAccessCurrent && steps.length > 0) {
      const firstStep = steps.find(step => !step.removeFromProgress);
      if (!firstStep) return;
      const fallbackRoute = flow.getAbsoluteRouteForStep(firstStep.stepRoute, locale);
      if (fallbackRoute) router.replace(fallbackRoute);
    }
  }, [canAccessCurrent, flow, isHydrated, locale, router, steps]);

  return null;
};
